import Model from '@/models/Model'

export default class WhTag extends Model {
    resource() {
        return 'wh_tag'
    }
}